import type { MonthlyData } from '@type/Summary';

export const MonthlyDataMapper: Array<keyof MonthlyData> = [
  '-',
  'JAN',
  'FEB',
  'MAR',
  'APR',
  'MAY',
  'JUN',
  'JUL',
  'AUG',
  'SEP',
  'OCT',
  'NOV',
  'DEC',
];
